import React from 'react';
import Hero from 'containers/Products/Hero';
import { ReactComponent as Funding } from 'assets/svg/funding.svg';
import { ReactComponent as DigitalWalletImage } from 'assets/svg/digital-wallet.svg';
import { ReactComponent as SecureTransfer } from 'assets/svg/secure.svg';
import { ReactComponent as Reliable } from 'assets/svg/reliable.svg';
import { ReactComponent as LowFees } from 'assets/svg/low-fees.svg';
import { ReactComponent as Finance } from 'assets/svg/finance-mgt.svg';
import Card from 'containers/MoneyTransfer/Card';
import FAQ from 'containers/Products/FAQ';
import { Helmet } from 'react-helmet-async';
import { digital_wallet } from 'constants/faq';
import CallToAction from 'components/CallToAction';
import { POUCHERS_WEBSITE_URL, POUCHERS_LOGO_URL } from 'constants';

export default function DigitalWallet() {
  return (
    <>
      <Helmet>
        <title>Best Digital Wallet | Manage Your Money - Pouchers</title>
        <meta name="title" content="Best Digital Wallet | Manage Your Money - Pouchers" />
        <meta
          name="description"
          content="Pouchers has one of the best and most convenient digital wallets to manage your funds. Make card payments and money transfers straight from your e-wallet."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${POUCHERS_WEBSITE_URL}/digital-wallet`} />
        <meta property="og:title" content="Best Digital Wallet | Manage Your Money - Pouchers" />
        <meta
          property="og:description"
          content="Pouchers has one of the best and most convenient digital wallets to manage your funds. Make card payments and money transfers straight from your e-wallet."
        />
        <meta property="og:image" content={POUCHERS_LOGO_URL} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={`${POUCHERS_WEBSITE_URL}/digital-wallet`} />
        <meta name="twitter:title" content="Best Digital Wallet | Manage Your Money - Pouchers" />
        <meta
          name="twitter:description"
          content="Pouchers has one of the best and most convenient digital wallets to manage your funds. Make card payments and money transfers straight from your e-wallet."
        />
        <meta name="twitter:image" content={POUCHERS_LOGO_URL} />
      </Helmet>
      <div className="bg-[#5034C40D]">
        <Hero
          title="Step Into the Future of Payments!"
          subTitle="Digital Wallet"
          description="Manage your money effortlessly with Pouchers E-Wallet. Top up easily and enjoy secure, convenient spending—anytime, anywhere."
          image={<DigitalWalletImage className="max-w-[284px] sm:max-w-[356px]" />}
          buttonName="Get Started"
          link="https://app.pouchers.io/create-account"
        />
      </div>
      <div className="container py-[80px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 justify-center">
          <Card
            icon={<Funding />}
            title="Multiple Funding Options"
            description="The Digital Wallet feature provides you with multiple funding options, such as vouchers, bank transfers, and card payments, making it easy for you to add funds to your e-wallet account. "
          />
          <Card
            icon={<Reliable />}
            title="Fast and Reliable Transactions"
            description="Enjoy fast and reliable transactions and money transfers between you and other users on Pouchers with the digital wallet. Say goodbye to delayed transactions via traditional bank transfers."
          />
          <Card
            icon={<LowFees />}
            title="Low Transaction Fees"
            description="Enjoy the lowest transaction fees while transacting digitally on Pouchers. Ditch the frequent and exorbitant charges associated with traditional banking transactions."
          />
          <Card
            icon={<Finance />}
            title="Financial Management"
            description="With Pouchers Digital Wallet feature, you can easily manage your finances. The e-wallet provides you with a clear view of your transactions, allowing you to track your spending and budget more effectively."
          />
        </div>
        <div className="flex justify-center mt-[24px]">
          <Card
            icon={<SecureTransfer />}
            title="Secure and Convenient"
            description="Go cashless without stress - Keep your funds safe and secure in the Pouchers digital wallet. Safeguard your hard-earned money from fraud or unnecessary charges."
            className="max-w-[554px]"
          />
        </div>
      </div>
      <FAQ questions={digital_wallet} type="digital wallet" />
      {/* <CallToAction
        title="Ready to say bye to bills & hi to freedom?."
        description="Take charge with Pouchers—automate bills, track spending, and get virtual cards. It’s your all-in-one financial sidekick!"
      /> */}
    </>
  );
}
